import React from 'react';

const PrivacyPage = () => {
  return (
    <div style={Styles.container}>
        <h1 style={Styles.title}>Privacy Policy for Buzzin</h1>
        <p style={Styles.text}>
        Last updated: October 6, 2026
        </p>
        <p style={Styles.text}>
        Buzzin is built so that your game night stays between you and your friends. This page explains what the app stores and what leaves your phone. The short version: everything is stored on your device, there is no account, and the only thing sent anywhere is anonymous performance and crash reports.
        </p>
        <br />
        <h3 style={Styles.subTitle}>No accounts</h3>
        <p style={Styles.text}>
        The app has no sign-up, sign-in or cloud sync. It never asks for your name, email address or Apple ID, and it does not create a profile of you anywhere.
        </p>
        <h3 style={Styles.subTitle}>What is stored on your device</h3>
        <p style={Styles.text}>
        The player names you type in at the start of a game, and your settings. They are kept on your phone so the game can deal cards to the right people, and they are never transmitted. All of this lives only on your iPhone, in the app's own storage. Deleting the app deletes it. If you use iCloud device backup, it is included in that backup like any other app data, under Apple's terms.
        </p>
        <h3 style={Styles.subTitle}>Analytics</h3>
        <p style={Styles.text}>
        Buzzin sends anonymous performance and crash reports to Expo's EAS Observe service so we can see whether the app launches quickly and whether it crashes. A report contains timings, any error that occurred, the app version, the platform and the device type, tagged with a random identifier that is unique to this install and resets if you delete and reinstall the app. Reports contain no player names, no free text, and nothing that identifies you. Expo processes these reports on our behalf and keeps them for at least 60 days. They are never sold, never shared with anyone else, and never used for advertising.
        </p>
        <h3 style={Styles.subTitle}>Children's Privacy</h3>
        <p style={Styles.text}>
        Buzzin does not collect any personal information from anyone, including children. The game is intended for people who are at least 18 years old or the legal drinking age in their jurisdiction.
        </p>
        <h3 style={Styles.subTitle}>Your choices</h3>
        <p style={Styles.text}>
        Delete the app to remove everything it stores.
        </p>
        <h3 style={Styles.subTitle}>This website</h3>
        <p style={Styles.text}>
        taci.uk uses Google Analytics to count visits and see which pages are read. It sets cookies in your browser and records the page you view, the site that linked you here, your browser, device type and approximate location (worked out from your IP address, which Google does not store). It is used only on this website, never inside the app, and is not linked to anything you do in the app. You can block it with a content blocker or Google's opt-out add-on at tools.google.com/dlpage/gaoptout.
        </p>
        <h3 style={Styles.subTitle}>Changes to this policy</h3>
        <p style={Styles.text}>
        If the app's handling of data changes, this page will change with it and the date above will be updated.
        </p>
        <h3 style={Styles.subTitle}>Contact</h3>
        <p style={Styles.text}>
        Buzzin is made by Michael Taciuk. Questions about privacy or the app can be sent to <a href="mailto:support@taci.uk">support@taci.uk</a>.
        </p>
    </div>
  );
};

const Styles = {
    container: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: 20,
        backgroundImage: 'url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cdefs%3E%3CradialGradient%20id%3D%22grad%22%20cx%3D%2250%25%22%20cy%3D%2250%25%22%20r%3D%2250%25%22%20fx%3D%2250%25%22%20fy%3D%2250%25%22%3E%3Cstop%20offset%3D%220%25%22%20stop-color%3D%22%23e8f0a0%22%20stop-opacity%3D%221%22%20/%3E%3Cstop%20offset%3D%22100%25%22%20stop-color%3D%22%23d5e841%22%20stop-opacity%3D%221%22%20/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect%20x%3D%220%22%20y%3D%220%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20fill%3D%22url(%23grad)%22%20/%3E%3C/svg%3E")',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '100vh',
    },
    title: {
        fontSize: 24,
        fontWeight: 'bold',
    },
    subTitle: {
        fontSize: 20,
        fontWeight: 'bold',
    },
    text: {
        fontSize: 16,
        width: '60%',
        minWidth: 300,
        textAlign: 'center',
    },
};

export default PrivacyPage;